const translations = {
    connectionError: 'Connection error. Click to retry.'
};

export default translations;
